export const USD = '$';
export const JPY = '￥';
export const BTC = 'BTC';
export const ETH = 'ETH';
export const THB = '฿';
export const IDR = 'Rp';
export const PHP = '₱';
export const MYR = 'RM';
export const VND = 'đ';
export const SZT = "SZT";

export const MapCurrency = {
  USD: USD,
  JPY: JPY,
  BTC: BTC,
  ETH: ETH,
  VND: VND,
  MYR: MYR,
  PHP: PHP,
  THB: THB,
  IDR: IDR,
  SZT: SZT,
};
export const MapCurrencyReserve = {
    '$': "USD",
    '￥': "JPY",
    'BTC': "BTC",
    'ETH': "ETH",
    'đ': "VND",
    'RM': "MYR",
    '₱': "PHP",
    '฿': "THB",
    'Rp': "IDR"
}

export const SUPPORT_CCY = [
  "USD",
  "JPY",
  "VND",
  "THB",
  "IDR",
  "PHP",
  "MYR",
  "SZT",
  "ETH",
];
export const SUPPORT_CCY_RESERVE = [
    '$',
    '￥',
    'BTC',
    'ETH',
    'đ',
    'RM',
    '฿',
    'Rp',
    '₱'
]
export const SUFIX_SUPPORT_CCY = ["SZT"];
export const SUFIX_SUPPORT_CCY_RESERVE = [
    
]

export const validateDecimalSeparator =  (ccy) => {
    if (ccy == "MYR" || ccy == "USD" || ccy == "SZT") {
      return 2;
    }
    return 0;
}


export const validateDecimalSeparator2 = (ccy) => {
    if (ccy == "MYR" || ccy == "USD") {
        return false;
    }
    return true;
}

export const baseCurrencyCode = (isLogin, userCcy, ipCcy) => {
    let baseCcy = 'USD';
    if(isLogin && SUPPORT_CCY.includes(userCcy)) {
        baseCcy = userCcy
    } else {
        if (ipCcy && SUPPORT_CCY_RESERVE.includes(ipCcy)) {
            baseCcy = MapCurrencyReserve[ipCcy]
        }
    }
    return baseCcy;
}

export const baseCurrencySymbol = (isLogin, userCcy, ipCcy) => {
    let baseCcy = USD;
    if (isLogin && SUPPORT_CCY.includes(userCcy)) {
        baseCcy = MapCurrency[userCcy]
    } else {
        if (ipCcy && SUPPORT_CCY_RESERVE.includes(ipCcy)) {
            baseCcy = ipCcy
        }
    }
    return baseCcy;
}
export const prefixCcySymbol = (isLogin, userCcy, ipCcy) => {
    let baseCcy = '';
    if (isLogin) {
        if (!SUFIX_SUPPORT_CCY.includes(userCcy)){
            baseCcy = SUPPORT_CCY.includes(userCcy) ? MapCurrency[userCcy] : USD
        }
    }else{
        if (!SUFIX_SUPPORT_CCY_RESERVE.includes(ipCcy)){
            baseCcy = SUPPORT_CCY_RESERVE.includes(ipCcy) ? ipCcy : USD;
        }
    }
    return baseCcy;
}

export const suffixCcySymbol = (isLogin, userCcy, ipCcy) => {
    let baseCcy = '';
    if (isLogin) {
        if (SUFIX_SUPPORT_CCY.includes(userCcy)) {
            baseCcy = SUPPORT_CCY.includes(userCcy) ? MapCurrency[userCcy] : USD
        }
    } else {
        if (SUFIX_SUPPORT_CCY_RESERVE.includes(ipCcy)) {
            baseCcy = SUPPORT_CCY_RESERVE.includes(ipCcy) ? ipCcy : USD;
        }
    }
    return baseCcy;
}

export const decimalAdjust = (type, value, exp) => {
  type = String(type);
  if (!["round", "floor", "ceil"].includes(type)) {
    throw new TypeError(
      "The type of decimal adjustment must be one of 'round', 'floor', or 'ceil'."
    );
  }
  exp = Number(exp);
  value = Number(value);
  if (exp % 1 !== 0 || Number.isNaN(value)) {
    return NaN;
  } else if (exp === 0) {
    return Math[type](value);
  }
  const [magnitude, exponent = 0] = value.toString().split("e");
  const adjustedValue = Math[type](`${magnitude}e${exponent - exp}`);
  // Shift back
  const [newMagnitude, newExponent = 0] = adjustedValue.toString().split("e");
  return Number(`${newMagnitude}e${+newExponent + exp}`);
};